import { render } from "./TestTick.vue?vue&type=template&id=14d7e22b&scoped=true"
import script from "./TestTick.vue?vue&type=script&lang=js"
export * from "./TestTick.vue?vue&type=script&lang=js"

import "./TestTick.vue?vue&type=style&index=0&id=14d7e22b&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d7e22b"]])

export default __exports__